"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends")),
    _react = _interopRequireDefault(require("react")),
    _Addons = require("../../Addons"),
    _PaymentsInvoice = _interopRequireDefault(require("../components/PaymentsInvoice")),
    _AuthorisationWrapper = require("../../AuthorisationWrapper"),
    _Credits = require("../../Credits"),
    _RequestProvider = _interopRequireDefault(require("../../RequestProvider")),
    _api = require("../api"),
    AddonsInvoiceBaseComp = function AddonsInvoiceBaseComp(props) {
  return _react["default"].createElement(_Addons.AddonsConsumer, null, function (_ref) {
    var _ref$actions = _ref.actions,
        getAddonsCost = _ref$actions.getAddonsCost,
        getCurrencySymbol = _ref$actions.getCurrencySymbol;
    return _react["default"].createElement(_Credits.CreditsConsumer, null, function (_ref2) {
      var onCreditsUpdated = _ref2.actions.onCreditsUpdated;
      return _react["default"].createElement(_PaymentsInvoice["default"], (0, _extends2["default"])({
        getAddonsCost: getAddonsCost,
        getCurrencySymbol: getCurrencySymbol,
        onCreditsUpdated: onCreditsUpdated
      }, props));
    });
  });
};

function AddonsInvoice(props) {
  var showCreditInfo = props.showCreditInfo;
  return showCreditInfo ? _react["default"].createElement(_AuthorisationWrapper.AuthorisationConsumer, null, function (_ref3) {
    var _ref3$selectedOrganis = _ref3.selectedOrganisation;
    _ref3$selectedOrganis = void 0 === _ref3$selectedOrganis ? {} : _ref3$selectedOrganis;
    var organisationId = _ref3$selectedOrganis.organisationId;
    return _react["default"].createElement(_RequestProvider["default"], {
      requests: {
        getTeamCredits: (0, _api.getTeamCredits)(organisationId),
        getOrgCredits: (0, _api.getOrgCredits)(organisationId)
      }
    }, function (requests) {
      return _react["default"].createElement(AddonsInvoiceBaseComp, (0, _extends2["default"])({}, props, requests));
    });
  }) : _react["default"].createElement(AddonsInvoiceBaseComp, props);
}

var _default = AddonsInvoice;
exports["default"] = _default;